<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import EvolutionTrack from "@/components/widgets/evolution-track";

export default {
  locales: {
    pt: {
      'Reports': 'Relatórios',
      'Evolution Plan': 'Plano de Evolução',
      'Personal PG': 'PG Pessoal',
      'Combo': 'Combo',
      'Graduation': 'Graduação',
      'Discount': 'Desconto',
      'Cumulative discount on all graduations': 'Desconto cumulativo em todas as graduações',
      'Discounts per level': 'Descontos por nível',
      'Become VIP': 'Seja VIP',
      'Become Ambassador': 'Seja Embaixador',
      'Become Diamond': 'Seja Diamond',
      'Achieved': 'Conquistado',
      'In progress': 'Em andamento',
      'Locked': 'Bloqueado',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
      'No records found.': 'Nenhum registro encontrado.',
    },
    es: {
      'Reports': 'Reportes',
      'Evolution Plan': 'Plan de Evolución',
      'Personal PG': 'PG Personal',
      'Combo': 'Combo',
      'Graduation': 'Graduación',
      'Discount': 'Desconto',
      'Cumulative discount on all graduations': 'Descuento acumulativo en todas las graduaciones',
      'Discounts per level': 'Descuentos por nivel',
      'Become VIP': 'Sé VIP',
      'Become Ambassador': 'Sé Embajador',
      'Become Diamond': 'Sé Diamond',
      'Achieved': 'Conquistado',
      'In progress': 'En progreso',
      'Locked': 'Bloqueado',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.',
      'No records found.': 'No se encontraron registros.',
    }
  },
  components: {
    Layout,
    Stat,
    EvolutionTrack
  },
  data() {
    return {
      // Descontos liberados por posição de nível (1 a 4)
      discounts: [
        { level: 1, percent: 35 },
        { level: 2, percent: 40 },
        { level: 3, percent: 45 },
        { level: 4, percent: 50 },
      ],

      // Trilhas de evolução — status: achieved | progress | locked
      tracks: null,

      // Estatísticas do relatório
      statData: null,
    };
  },
  computed: {
    // Descontos já com o estado de liberação resolvido, para desktop e mobile
    // lerem exatamente a mesma regra
    discountsList() {
      return this.discounts.map((discount, index) => {
        return {
          level: discount.level,
          percent: discount.percent,
          unlocked: this.isDiscountUnlocked(index),
        };
      });
    },
  },
  methods: {
    getEvolucao() {
      this.tracks = null;

      api
        .get("reports/evolucao")
        .then((response) => {
          if (response.data.status == "success") {
            this.tracks = response.data.tracks;

            this.statData = [
              {
                type: "line",
                icon: "bx-chart",
                title: "Personal PG",
                value: this.$options.filters.points(response.data.points),
                month: true,
              },
              {
                type: "line",
                icon: "bx-package",
                title: "Combo",
                value: response.data.plan,
              },
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduation",
                value: response.data.graduation,
                month: true,
              },
              {
                type: "line",
                icon: "bx-dollar",
                title: "Discount",
                value: response.data.discount,
              }
            ];
          } else {
            this.tracks = [];
          }
        })
        .catch(() => {
          this.tracks = [];
        })
    },
    // O desconto de uma posição conta como liberado quando PELO MENOS UMA das
    // trilhas já conquistou o nível daquela posição — o desconto vale pela
    // graduação mais avançada, independente da trilha
    isDiscountUnlocked(index) {
      if (!this.tracks || this.tracks.length == 0) {
        return false;
      }
      return this.tracks.some((track) => {
        const level = track.levels[index];
        return level && level.status == 'achieved';
      });
    },
  },
  mounted() {
    this.getEvolucao();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Reports') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Evolution Plan') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :month="stat.month" />
      </div>
    </div>

    <div v-if="!tracks" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="tracks && tracks.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="d-flex justify-content-center align-items-center mb-3">
          <div class="evolution-note mt-2 mt-md-0">
            <i class="bx bx-purchase-tag-alt"></i>
            {{ t('Cumulative discount on all graduations') }}
          </div>
        </div>

        <!-- Faixa de descontos por nível (somente desktop) -->
        <div class="evolution-discounts d-none d-md-flex">
          <div class="evolution-discounts-label">
            {{ t('Discounts per level') }}
          </div>
          <div class="evolution-discounts-values">
            <div v-for="discount in discountsList" :key="discount.level" class="evolution-discounts-item" :class="{ 'is-locked': !discount.unlocked }">
              <span class="evolution-discounts-badge">{{ discount.level }}</span>
              <div class="evolution-discounts-percent">{{ discount.percent }}%</div>
            </div>
          </div>
        </div>

        <!-- Trilhas -->
        <div class="evolution-tracks">
          <EvolutionTrack
            v-for="track in tracks"
            :key="track.key"
            :label="t(track.label)"
            :icon="track.icon"
            :variant="track.variant"
            :levels="track.levels"
            :discounts="discountsList"
          />
        </div>

        <!-- Legenda -->
        <div class="evolution-legend d-flex justify-content-center flex-wrap">
          <div class="evolution-legend-item">
            <span class="evolution-legend-dot is-achieved">
              <i class="bx bx-check"></i>
            </span>
            {{ t('Achieved') }}
          </div>
          <div class="evolution-legend-item">
            <span class="evolution-legend-dot is-progress">
              <i class="bx bx-play"></i>
            </span>
            {{ t('In progress') }}
          </div>
          <div class="evolution-legend-item is-locked">
            <span class="evolution-legend-dot is-locked">
              <i class="bx bx-hourglass"></i>
            </span>
            {{ t('Locked') }}
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.evolution-note {
  color: #6c757d;
  font-size: 14px;
}
.evolution-note i {
  vertical-align: middle;
  font-size: 18px;
}

/* ===== Faixa de descontos (desktop) ===== */
.evolution-discounts {
  align-items: center;
  background: #fafafa;
  border-radius: 12px;
  padding: 14px 0;
}
/* Mesma largura da coluna de rótulo da trilha (250px), com o recuo interno
   por dentro para as colunas de % caírem exatamente sobre os nós */
.evolution-discounts-label {
  width: 250px;
  min-width: 250px;
  padding-left: 16px;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.25;
}
/* Mesmo grid da trilha: 4 colunas de largura igual, conteúdo centralizado */
.evolution-discounts-values {
  display: flex;
  flex: 1;
  padding-left: 24px;
}
.evolution-discounts-item {
  flex: 1;
  min-width: 0;
  text-align: center;
}
.evolution-discounts-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 6px;
  background: #0f9d58;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
/* Coluna bloqueada: mesma leitura cinza dos níveis ainda não atingidos */
.evolution-discounts-item.is-locked .evolution-discounts-badge {
  background: #e9ecef;
  color: #adb5bd;
}
.evolution-discounts-item.is-locked .evolution-discounts-percent {
  color: #adb5bd;
}
.evolution-discounts-percent {
  color: #0f9d58;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
}

/* ===== Legenda ===== */
.evolution-legend {
  padding-top: 16px;
  margin-top: 8px;
}
.evolution-legend-item {
  display: flex;
  align-items: center;
  margin-right: 28px;
  font-size: 14px;
  color: #343a40;
}
.evolution-legend-item.is-locked {
  color: #adb5bd;
}
/* Bolinha da legenda: mesma leitura dos nós da trilha, em escala reduzida */
.evolution-legend-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 100%;
  border: 2px solid transparent;
  margin-right: 8px;
  font-size: 14px;
  line-height: 1;
}
.evolution-legend-dot.is-achieved {
  background: #343a40;
  color: #fff;
}
.evolution-legend-dot.is-progress {
  border-color: #343a40;
  color: #343a40;
}
.evolution-legend-dot.is-locked {
  border-color: #dee2e6;
  color: #adb5bd;
}

@media (max-width: 767.98px) {
  .evolution-legend-item {
    margin-right: 18px;
    margin-bottom: 6px;
    font-size: 13px;
  }
}
</style>
